import { render, staticRenderFns } from "./signpwd.vue?vue&type=template&id=46fd2988&lang=pug&"
import script from "./signpwd.vue?vue&type=script&lang=js&"
export * from "./signpwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports